
<!-- begin::User -->
<div
  class="d-flex align-items-center"
  [ngClass]="toolbarButtonMarginClass"
  id="qrpay_header_user_menu_toggle"
>
  <!-- begin::Toggle -->

<div
    class="cursor-pointer symbol d-flex align-items-center"
    [ngClass]="toolbarUserAvatarHeightClass"
    data-kt-menu-trigger="click"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
    data-kt-menu-flip="bottom"
  >
    <img *ngIf="!user.currentUserValue.profile_picture" src="/assets/media/icons/custom/user.svg" alt="Avatar" />
    <img *ngIf="user.currentUserValue.profile_picture" [src]="user.currentUserValue.profile_picture" alt="Avatar" />

  </div>
  <!-- end::Toggle  -->
  <app-user-inner></app-user-inner>
</div>
<!-- end::User -->

